import { defineStore } from "pinia"
import { ref } from "vue"
import { sleep } from "@/helpers/sleep"
import { brainActor } from "@/features/brain/machines/brainMachine"

export const useBrainTutoStore = defineStore("brainTutoStore", () => {
  const isTutorial = ref(true) // default true - false for testing
  const isTutoError = ref(false)
  const tutoAnswerIsPlaying = ref(false)
  const currentTutoStep = ref(0)
  const instructionsDone = ref(false)

  function restartTutorial() {
    isTutorial.value = true
    currentTutoStep.value = 0
    brainActor.send({ type: "restart" })
  }

  async function revealAnswer() {
    window.b.rawResetTest()
    window.b.playAnswer(currentTutoStep.value)
  }

  async function submitTutoStep() {
    window.b.onSubmitTutoStep()
  }

  async function openTutoErrorModal() {
    isTutoError.value = true
    await sleep(4000)
    isTutoError.value = false
  }

  return {
    isTutorial,
    isTutoError,
    tutoAnswerIsPlaying,
    currentTutoStep,
    instructionsDone,
    revealAnswer,
    submitTutoStep,
    openTutoErrorModal,
    restartTutorial,
  }
})
